import BaseUIProfileView from 'xui/modules/profile/BaseUIProfileView'

class ProfileView extends BaseUIProfileView {
  static displayName = 'ProfileView'
}
export default ProfileView
